<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>

    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center">
      Pengajuan Sertifikat  
    </CCardHeader>    

    <CCardBody>
      <CRow >
        <div class="col-sm-6 col-xl-16">
          <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Periode</label>
            <multiselect
              class="mulit-select"
              label="label"
              placeholder="Pilih Periode"
              :show-labels="false"
              required
              v-model="periode"
              @select="changePeriode"
              :options="dataPeriode"
              :loading="loading"
            ></multiselect>
          </div>
        </div>
        <div class="col-sm-6 col-xl-16">
          <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Sertifikasi RPL</label>
            <multiselect
              class="mulit-select"
              label="nama_rpl"
              track-by="nama_rpl"
              placeholder="Pilih RPL"
              :show-labels="false"
              required
              v-model="kategoriRpl"
              @select="changeKategoriRpl"
              :options="dataKategoriRpl"
              :loading="loadingMultiSelect.isLoadingRpl"
            ></multiselect>
          </div>
        </div>
        <div class="col-sm-12 col-xl-12 mb-3">
          <div style="float:right">
            <button class="btn btn-info" @click="resetFilter">Reset Filter</button>&nbsp;
            <button class="btn btn-success" @click="filterData">Terapkan</button>
          </div>
        </div>
      </CRow>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" name id class="form-control" placeholder="Cari Data ..." v-model="searchRpl" />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index + 1: index + indexed + 1}}</td>
            </template>

            <template #no_anggota="{ item }">
              <td class="py-2 font-weight-bold">
                {{ item.no_anggota ? item.no_anggota : "-" }}
              </td>
            </template>
            <template #nama_lengkap="{ item, index }">
              <td
                class="py-2 text-info"
                style="cursor: pointer"
                @click="detailUser(item, index)">
                {{ item.nama_lengkap ? item.nama_lengkap : "-" }}
              </td>
            </template>

            <template #status_pengajuan="{item}">
              <td class="py-2 text-center">
                <span v-if="item.status_pengajuan == 0"   class="font-weight-bold text-warning">
                  Daftar Pengajuan 
                </span>
                <span v-else-if="item.status_pengajuan == 1"   class="font-weight-bold text-success">
                  Pengajuan Diterima 
                </span>
                <span class="font-weight-bold text-danger" v-else>
                  Pengajuan Tidak Diterima
                </span>
              </td>
            </template>
            <template #status_pengambilan="{item}">
              <td class="py-2 text-center">
                <span v-if="item.status_pengambilan == 0"   class="font-weight-bold text-warning">
                  Belum Diambil 
                </span>
                <span v-else-if="item.status_pengambilan == 1"   class="font-weight-bold text-success">
                  Sudah Diambil 
                </span>
                <span class="font-weight-bold text-warning" v-else>
                  Belum Diambil
                </span>
              </td>
            </template>
            <template #aksi={item}>
              <td class="py-2 text-center">
                <template v-if="role_status && role_status.status_update">  
                  <button 
                  v-c-tooltip="'Ubah'" 
                  :disabled="item.status_dokumen == '0'"
                  :class="item.status_dokumen == '0' ? 'btn btn-sm btn-secondary text-white mr-2' : 'btn btn-sm btn-info text-white mr-2' " 
                  @click="verifPengajuan(item)">
                  <font-awesome-icon icon="edit" />
                </button>
                </template>
                <template v-else>
                  <button 
                  v-c-tooltip="'Ubah'" 
                  disabled
                  class="btn btn-sm btn-secondary text-white mr-2">
                  <font-awesome-icon icon="edit" />
                </button>
                </template>
                <template v-if="role_status && role_status.status_read">
                <router-link v-c-tooltip="'Lihat Dokumen'" class="btn btn-sm btn-warning text-white" square :to="'/rpl/pengajuan-sertifikat-rpl/data-dokumen/'+item.id_pengajuan_penerbitan">
                  <font-awesome-icon icon="file" />
                </router-link>
                </template>
                <template v-else>
                <router-link 
                v-c-tooltip="'Lihat Dokumen'" 
                class="btn btn-sm btn-secondary text-white" 
                square 
                :to="'/rpl/pengajuan-sertifikat-rpl/data-dokumen/'+item.id_pengajuan_penerbitan"
                tag="button"
                :disabled="true"
                >
                  <font-awesome-icon icon="file" />
                </router-link>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
          />
        </CCol>
      </CRow>

      <CModal
        title="Modal title"
        :show.sync="modalVerif"
        :no-close-on-backdrop="true"
        :centered="true"
        @submit.prevent="postData"
      >
        <CForm>
          <CRow>
            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <select name="id_outlet" class="form-control mb-2" id="status_pengajuan"
              :class="{
                  'is-invalid': $v.formData.statusPengajuan.$error,
                }"
              v-model="formData.statusPengajuan">
                <option value="0" disabled>Pengajuan</option>
                <option value="1">Diterima</option>
                <option value="2">Tidak Diterima</option>
              </select>
            </CCol>

            <CCol sm="12 mb-4" v-show="formData.statusPengajuan == '1'">
              <label for class="font-weight-bold">Kode Sertifikat</label>
              <br />
              <input type="text" class="form-control" id="kode_sertifikat" 
              :class="{
                  'is-invalid' : $v.formData.kodeSertifikat.$error,
                }"
                v-model="formData.kodeSertifikat">
            </CCol>
            <CCol sm="12 mb-4" v-show="formData.statusPengajuan == '1'">
              <label for class="font-weight-bold">No Sertifikat</label>
              <br />
              <input type="number" class="form-control" id="no_sertifikat" 
              :class="{
                  'is-invalid' : $v.formData.noSertifikat.$error,
              }"
              v-model="formData.noSertifikat">
            </CCol>
            <CCol sm="12 mb-4" v-show="formData.statusPengajuan == '1'">
              <label for class="font-weight-bold">Tanggal Pengambilan</label>
              <br />
              <input type="date" class="form-control" id="tanggal_pengambilan" 
              :class="{
                  'is-invalid' : $v.formData.tanggalPengambilan.$error,
              }"
              v-model="formData.tanggalPengambilan" :min="today">
            </CCol>
            <CCol sm="12 mb-4" v-show="formData.statusPengajuan == '1'">
              <label for class="font-weight-bold">Status Pengambilan</label>
              <br />
              <select name="id_outlet" class="form-control mb-2"  id="status_pengembalian"
              :class="{
                  'is-invalid' : $v.formData.statusPengambilan.$error,
              }"
              v-model="formData.statusPengambilan">
                <option value disabled selected>Pilih Status Pengambilan</option>
                <option value="0">Belum Diambil</option>
                <option value="1">Sudah Diambil</option>
              </select>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Verifikasi Pengajuan Sertifikat</h6>
        </template>
        <template #footer>
          <CButton @click="modalVerif = false" color="danger">Tutup</CButton>
          <CButton type="submit" @click="postData" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->

      <!-- Modal Detail User -->
      <ModalDetailPesertaSertifikasi
        :modalDetail="modalDetail"
        :title="modalTitle"
        :formData="formData"
        @closeModalDetail="closeModalDetail($event)"
      />

    </CCardBody>
  </CCard>    
    <!-- end data kota/kab -->

    

</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { PaginationPengajuanSertifikat } from "@/mixins/paginationType/PaginationPengajuanSertifikat";
import { AlertUtils } from "@/mixins/AlertUtils";

import PengajuanPenerbitanSertifikatRplService from "@/services/rpl/data-penerbitan-sertifikat-rpl.service"
import PeriodeRplService from '@/services/datamaster/periode-rpl.service';
import ModalDetailPesertaSertifikasi from "@/components/sertifikasi/datapeserta/ModalDetailPesertaSertifikasi";
import DataPesertaRplService from "@/services/rpl/data-peserta-rpl.service"
import TemplateECertificate from '../../pelatihan/ECertificate/TemplateECertificate.vue';


const fields = [
  { key: "no" },
  {
    key: "no_anggota",
    label: "No Anggota",
  },{
    key: "nama_lengkap",
    label: "Nama Anggota",
  },
  {
    key: "nama_rpl",
    label: "Nama RPL",
  },
  {
    key: "created_at",
    label: "Tanggal Pengajuan RPL",
  },
  {
    key: "status_pengajuan",
    label: "Status Pengajuan",
    _style: "text-align: center",
  },
  {
    key: "status_pengambilan",
    label: "Status Pengambilan",
    _style: "text-align: center",
  },
  {
    key: "aksi",
    _style: "width:12%; text-align: center",
  },
];

export default {
  mixins : [
    PaginationPengajuanSertifikat,
    AlertUtils
  ],
  components: {
    ModalDetailPesertaSertifikasi
  },

  data() {
    return {
      loadingMultiSelect : {
        isLoadingPeriode : true,
        isLoadingRpl : true,
      },
      formFilter : {
        periode : '',
        idSertifikasiRpl : ''
      },
      items: [],
      fields,
      dataSertifikasi : [],
      sertifikasi: {},
      periode : {},
      dataPeriode : [],
      kategoriRpl: '',
      modalTitle: '',
      dataKategoriRpl: [],
      today : "",
      searchRpl : '',
      formData : {
        id_pengajuan_penerbitan : "",
        kodeSertifikat : "",
        noSertifikat : "",
        statusPengajuan : "1",
        tanggalPengambilan:'',
        statusPengambilan:''
      },
      modalVerif: false,
      loading: true,
      modalDetail: false,
      role_status: null
    }
  },
  validations : {
    formData : {
      kodeSertifikat : {required},
      noSertifikat : {required},
      statusPengajuan : {required},
      tanggalPengambilan : {required},
      statusPengambilan : {required}
    }
  },
  watch: {
    modalVerif: function() {
      if(this.modalVerif === false) {
        this.$v.$reset();
      }
    }
  },
  mounted() {
    this.getPeriode();
    this.today = moment().format("YYYY-MM-DD")
    this.roleData();
  },
  methods : {    
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    },
    changeKategoriRpl(value) {      
      this.formFilter.idSertifikasiRpl = value.id_sertifikasi_rpl        
    },
    getKategoriRpl() {

      var vm = this;
      this.loadingMultiSelect.isLoadingRpl = true;      
      DataPesertaRplService.getKategoriPesertaRpl()
        .then(response => {

          // comment console console.log(response.data.data + ' data sertifikasi rpl')
          this.dataKategoriRpl = response.data.data;
          this.kategoriRpl = this.dataKategoriRpl[0]
          this.formFilter.idSertifikasiRpl = this.kategoriRpl.id_sertifikasi_rpl;
          this.loadingMultiSelect.isLoadingRpl = false;
          this.filterData()
        })
        .catch(error => {          
          // comment console console.log(error)
          this.loadingMultiSelect.isLoadingRpl = false;
        })
    },

    changePeriode(e) {
      this.formFilter.periode = e.value
    },

    changeKategoriRpl(value) {      
      this.formFilter.idSertifikasiRpl = value.id_sertifikasi_rpl        
    },
    changeSertifikasi(e) {      
      this.formFilter.idSertifikasi = e.id_sertifikasi;
    },

    filterData() {            
      this.getData("0", this.pageSize, this.search, this.formFilter.periode, this.formFilter.idSertifikasiRpl);
    },

    resetFilter() {      
      this.formFilter.periode = ''
      this.formFilter.idSertifikasiRpl = ''
      this.sertifikasi = {}
      this.periode = {}
      this.items = []
    },

    detailUser(item, index) {
      this.modalDetail = true;
      this.formData = item;
    },

    closeModalDetail(e) {
      if(e === false) {
        this.modalDetail = false;
      }
    },

    resetFilter() {
      this.periode = '';
      this.kategoriRpl = '';            
    },  
    
    getPeriode() {
      this.loadingMultiSelect.isLoadingPeriode = true;
      PeriodeRplService.getPeriodeSelect()
        .then(response => {
          this.loading = false
          this.dataPeriode = response.data.data
          this.periode = this.dataPeriode.find(el => el.status === "1");      
          if(this.periode == undefined) {
            this.formFilter.periode = ''
            this.loadingMultiSelect.isLoadingPeriode = false;   
          } else {
            this.formFilter.periode = this.periode.value; 
            this.loadingMultiSelect.isLoadingPeriode = false;   
          }
          this.getKategoriRpl();
        })
        .catch(error => {          
          // comment console console.log(error)
          this.loadingMultiSelect.isLoadingPeriode = false;   
        })      
    },
   
    postData(){
      this.$v.formData.$touch();
      if (this.$v.formData.$invalid) {
        return;
      }else{
        this.insertData()
      }
    },

    insertData() {
      let loader = this.$loading.show({
          container: false ? null : this.$refs.formContainer,
          canCancel: true,
          onCancel: this.onCancel
        });
        PengajuanPenerbitanSertifikatRplService.putJadwalTc(this.formData)
          .then(response => {          
            this.modalVerif = false;
            loader.hide()          
            this.alertSuccess();                    
            this.getData(this.currentPage - 1, this.pageSize, this.search, this.formFilter.periode, this.formFilter.idSertifikasiRpl);
          })        
          .catch(error => {
            this.modalVerif = false;
            this.alertError(error.response.data.message);
          })
    },

    verifPengajuan(item){
      this.modalVerif = true;
      this.formData.id_pengajuan_penerbitan = item.id_pengajuan_penerbitan;
      this.formData.statusPengajuan = item.status_pengajuan;
      this.formData.kodeSertifikat = item.kode_sertifikat;
      this.formData.noSertifikat = item.no_sertifikat;
      this.formData.tanggalPengambilan = item.tanggal_pengambilan;
      this.formData.statusPengambilan = item.status_pengambilan;
    },

    getData(currentPage, pageSize, search, periode, idSertifikasi){
      var vm = this;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      PengajuanPenerbitanSertifikatRplService.getData(currentPage, pageSize, search, periode, idSertifikasi)
        .then(response => {                    
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;
          loader.hide();
          this.loading = false
        }).catch(error => {
          this.alertError()
          loader.hide();
          this.loading = false
        })
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>